import { useCallback } from 'react';

import { useLocalForageState } from '../../../common/reactQuery/hooks/useLocalForageState';

import { StockTabs } from '../../stockConstants';

import { StockCache } from '../../StockCache';

interface ThreeDStockContentViewOptions {
  tab: StockTabs;
}

function useThreeDStockContentView({ tab }: ThreeDStockContentViewOptions) {
  const {
    value: isGridView,
    setValue: setGridView,
    fetched: isGridViewFetched
  } = useLocalForageState<boolean>(StockCache.viewCacheKey(tab), true);

  const handleToggleView = useCallback<() => void>(() => {
    setGridView(!isGridView);
  }, [isGridView, setGridView]);

  return {
    isGridView,
    handleToggleView,
    isGridViewFetched
  };
}

export default useThreeDStockContentView;
